export let mePoints = [
    {"x":114,"y":210.25},
    {"x":122,"y":208.25},
    {"x":130,"y":206.25},
    {"x":138,"y":206.25},
    {"x":146,"y":206.25},
    {"x":154,"y":202.25},
    {"x":164,"y":202.25},
    {"x":174,"y":204.25},
    {"x":182,"y":206.25},
    {"x":188,"y":208.25},
    {"x":194,"y":210.25},
    {"x":200,"y":212.25},
    {"x":206,"y":216.25},
    {"x":210,"y":222.25},
    {"x":212,"y":228.25},
    {"x":214,"y":234.25},
    {"x":216,"y":240.25},
    {"x":216,"y":248.25},
    {"x":216,"y":240.25},
    {"x":212,"y":234.25},
    {"x":206,"y":230.25},
    {"x":200,"y":228.25},
    {"x":194,"y":226.25},
    {"x":186,"y":226.25},
    {"x":180,"y":228.25},
    {"x":174,"y":234.25},
    {"x":170,"y":240.25},
    {"x":170,"y":250.25},
    {"x":170,"y":258.25},
    {"x":172,"y":264.25},
    {"x":178,"y":270.25},
    {"x":184,"y":268.25},
    {"x":188,"y":262.25},
    {"x":190,"y":256.25},
    {"x":192,"y":250.25},
    {"x":190,"y":242.25},
    {"x":186,"y":236.25},
    {"x":180,"y":234.25},
    {"x":172,"y":234.25},
    {"x":164,"y":234.25},
    {"x":158,"y":236.25},
    {"x":150,"y":238.25},
    {"x":144,"y":242.25},
    {"x":140,"y":248.25},
    {"x":144,"y":242.25},
    {"x":150,"y":240.25},
    {"x":156,"y":234.25},
    {"x":162,"y":232.25},
    {"x":168,"y":228.25},
    {"x":174,"y":226.25},
    {"x":180,"y":224.25},
    {"x":186,"y":220.25},
    {"x":192,"y":218.25},
    {"x":198,"y":216.25},
    {"x":206,"y":216.25},
    {"x":214,"y":218.25},
    {"x":216,"y":224.25},
    {"x":222,"y":226.25},
    {"x":230,"y":226.25},
    {"x":238,"y":226.25},
    {"x":246,"y":226.25},
    {"x":254,"y":226.25},
    {"x":260,"y":224.25},
    {"x":266,"y":220.25},
    {"x":272,"y":216.25},
    {"x":278,"y":214.25},
    {"x":284,"y":212.25},
    {"x":290,"y":208.25},
    {"x":296,"y":206.25},
    {"x":304,"y":206.25},
    {"x":312,"y":206.25},
    {"x":320,"y":206.25},
    {"x":326,"y":208.25},
    {"x":332,"y":212.25},
    {"x":336,"y":218.25},
    {"x":340,"y":224.25},
    {"x":344,"y":230.25},
    {"x":344,"y":238.25},
    {"x":342,"y":230.25},
    {"x":340,"y":224.25},
    {"x":334,"y":220.25},
    {"x":328,"y":216.25},
    {"x":320,"y":216.25},
    {"x":314,"y":220.25},
    {"x":310,"y":226.25},
    {"x":306,"y":234.25},
    {"x":306,"y":242.25},
    {"x":306,"y":250.25},
    {"x":308,"y":256.25},
    {"x":316,"y":256.25},
    {"x":320,"y":250.25},
    {"x":322,"y":242.25},
    {"x":322,"y":234.25},
    {"x":322,"y":226.25},
    {"x":320,"y":220.25},
    {"x":314,"y":218.25},
    {"x":306,"y":218.25},
    {"x":300,"y":222.25},
    {"x":294,"y":226.25},
    {"x":288,"y":230.25},
    {"x":282,"y":236.25},
    {"x":280,"y":242.25},
    {"x":286,"y":238.25},
    {"x":292,"y":232.25},
    {"x":296,"y":226.25},
    {"x":300,"y":220.25},
    {"x":306,"y":218.25},
    {"x":314,"y":214.25},
    {"x":320,"y":210.25},
    {"x":326,"y":208.25},
    {"x":334,"y":208.25},
    {"x":342,"y":208.25},
    {"x":350,"y":208.25},
    {"x":356,"y":210.25},
    {"x":362,"y":212.25},
    {"x":362,"y":220.25},
    {"x":362,"y":228.25},
    {"x":360,"y":234.25},
    {"x":358,"y":240.25},
    {"x":356,"y":246.25},
    {"x":354,"y":252.25},
    {"x":352,"y":258.25},
    {"x":350,"y":264.25},
    {"x":348,"y":270.25},
    {"x":344,"y":276.25},
    {"x":338,"y":280.25},
    {"x":332,"y":282.25},
    {"x":326,"y":284.25},
    {"x":320,"y":286.25},
    {"x":312,"y":286.25},
    {"x":304,"y":286.25},
    {"x":296,"y":286.25},
    {"x":288,"y":286.25},
    {"x":282,"y":284.25},
    {"x":276,"y":278.25},
    {"x":272,"y":272.25},
    {"x":266,"y":268.25},
    {"x":264,"y":262.25},
    {"x":262,"y":254.25},
    {"x":262,"y":246.25},
    {"x":258,"y":240.25},
    {"x":252,"y":236.25},
    {"x":250,"y":242.25},
    {"x":250,"y":250.25},
    {"x":250,"y":258.25},
    {"x":250,"y":266.25},
    {"x":250,"y":274.25},
    {"x":252,"y":280.25},
    {"x":258,"y":282.25},
    {"x":260,"y":288.25},
    {"x":262,"y":294.25},
    {"x":264,"y":300.25},
    {"x":264,"y":308.25},
    {"x":264,"y":316.25},
    {"x":262,"y":322.25},
    {"x":254,"y":322.25},
    {"x":254,"y":330.25},
    {"x":254,"y":338.25},
    {"x":252,"y":344.25},
    {"x":250,"y":350.25},
    {"x":258,"y":352.25},
    {"x":266,"y":352.25},
    {"x":274,"y":352.25},
    {"x":282,"y":352.25},
    {"x":288,"y":350.25},
    {"x":294,"y":352.25},
    {"x":302,"y":352.25},
    {"x":300,"y":358.25},
    {"x":294,"y":360.25},
    {"x":288,"y":362.25},
    {"x":282,"y":364.25},
    {"x":274,"y":364.25},
    {"x":266,"y":364.25},
    {"x":258,"y":364.25},
    {"x":250,"y":364.25},
    {"x":242,"y":364.25},
    {"x":234,"y":364.25},
    {"x":226,"y":364.25},
    {"x":218,"y":364.25},
    {"x":212,"y":362.25},
    {"x":206,"y":360.25},
    {"x":200,"y":358.25},
    {"x":198,"y":352.25},
    {"x":206,"y":352.25},
    {"x":214,"y":352.25},
    {"x":222,"y":354.25},
    {"x":230,"y":354.25},
    {"x":238,"y":354.25},
    {"x":246,"y":354.25},
    {"x":252,"y":352.25},
    {"x":252,"y":344.25},
    {"x":252,"y":336.25},
    {"x":252,"y":328.25},
    {"x":250,"y":322.25},
    {"x":244,"y":324.25},
    {"x":238,"y":320.25},
    {"x":236,"y":314.25},
    {"x":234,"y":308.25},
    {"x":234,"y":300.25},
    {"x":238,"y":294.25},
    {"x":242,"y":288.25},
    {"x":246,"y":282.25},
    {"x":248,"y":276.25},
    {"x":248,"y":268.25},
    {"x":248,"y":260.25},
    {"x":248,"y":252.25},
    {"x":248,"y":244.25},
    {"x":242,"y":242.25},
    {"x":236,"y":240.25},
    {"x":230,"y":236.25},
    {"x":224,"y":232.25},
    {"x":224,"y":242.25},
    {"x":222,"y":248.25},
    {"x":220,"y":254.25},
    {"x":218,"y":262.25},
    {"x":216,"y":268.25},
    {"x":212,"y":274.25},
    {"x":206,"y":280.25},
    {"x":202,"y":286.25},
    {"x":196,"y":290.25},
    {"x":190,"y":292.25},
    {"x":184,"y":294.25},
    {"x":178,"y":296.25},
    {"x":170,"y":296.25},
    {"x":162,"y":296.25},
    {"x":154,"y":296.25},
    {"x":148,"y":292.25},
    {"x":142,"y":286.25},
    {"x":136,"y":282.25},
    {"x":132,"y":276.25},
    {"x":128,"y":270.25},
    {"x":124,"y":264.25},
    {"x":122,"y":258.25},
    {"x":122,"y":250.25},
    {"x":120,"y":244.25},
    {"x":118,"y":238.25},
    {"x":118,"y":230.25},
    {"x":118,"y":222.25},
    {"x":124,"y":218.25},
    {"x":130,"y":214.25},
    {"x":136,"y":210.25},
    {"x":142,"y":208.25},
    {"x":150,"y":208.25},
    {"x":156,"y":206.25},
    {"x":174,"y":204.25},
    {"x":182,"y":204.25},
    {"x":190,"y":202.25},
    {"x":196,"y":200.25},
    {"x":202,"y":198.25},
    {"x":210,"y":198.25},
    {"x":218,"y":198.25},
    {"x":224,"y":196.25},
    {"x":232,"y":196.25},
    {"x":240,"y":196.25},
    {"x":248,"y":196.25},
    {"x":256,"y":196.25},
    {"x":264,"y":196.25},
    {"x":270,"y":198.25},
    {"x":276,"y":200.25},
    {"x":284,"y":200.25},
    {"x":290,"y":204.25},
    {"x":298,"y":204.25},
    {"x":304,"y":206.25},
    {"x":310,"y":204.25},
    {"x":318,"y":204.25},
    {"x":326,"y":204.25},
    {"x":332,"y":206.25},
    {"x":340,"y":206.25},
    {"x":346,"y":208.25},
    {"x":354,"y":208.25},
    {"x":360,"y":210.25},
    {"x":366,"y":220.25},
    {"x":374,"y":220.25},
    {"x":380,"y":222.25},
    {"x":386,"y":224.25},
    {"x":388,"y":230.25},
    {"x":388,"y":238.25},
    {"x":388,"y":246.25},
    {"x":388,"y":254.25},
    {"x":386,"y":260.25},
    {"x":382,"y":266.25},
    {"x":378,"y":272.25},
    {"x":372,"y":276.25},
    {"x":368,"y":282.25},
    {"x":362,"y":284.25},
    {"x":358,"y":290.25},
    {"x":352,"y":292.25},
    {"x":350,"y":300.25},
    {"x":350,"y":308.25},
    {"x":348,"y":314.25},
    {"x":346,"y":320.25},
    {"x":344,"y":328.25},
    {"x":344,"y":338.25},
    {"x":344,"y":346.25},
    {"x":342,"y":354.25},
    {"x":342,"y":362.25},
    {"x":342,"y":370.25},
    {"x":340,"y":378.25},
    {"x":334,"y":382.25},
    {"x":328,"y":386.25},
    {"x":322,"y":392.25},
    {"x":316,"y":398.25},
    {"x":310,"y":402.25},
    {"x":304,"y":406.25},
    {"x":298,"y":408.25},
    {"x":292,"y":410.25},
    {"x":286,"y":412.25},
    {"x":280,"y":416.25},
    {"x":274,"y":422.25},
    {"x":268,"y":424.25},
    {"x":262,"y":428.25},
    {"x":256,"y":430.25},
    {"x":246,"y":430.25},
    {"x":238,"y":430.25},
    {"x":232,"y":428.25},
    {"x":226,"y":426.25},
    {"x":220,"y":424.25},
    {"x":214,"y":418.25},
    {"x":208,"y":416.25},
    {"x":200,"y":412.25},
    {"x":194,"y":408.25},
    {"x":188,"y":406.25},
    {"x":182,"y":402.25},
    {"x":176,"y":396.25},
    {"x":170,"y":392.25},
    {"x":164,"y":388.25},
    {"x":158,"y":384.25},
    {"x":154,"y":378.25},
    {"x":148,"y":374.25},
    {"x":142,"y":372.25},
    {"x":136,"y":368.25},
    {"x":134,"y":362.25},
    {"x":134,"y":354.25},
    {"x":134,"y":346.25},
    {"x":134,"y":338.25},
    {"x":134,"y":330.25},
    {"x":134,"y":322.25},
    {"x":132,"y":316.25},
    {"x":132,"y":308.25},
    {"x":132,"y":300.25},
    {"x":132,"y":292.25},
    {"x":132,"y":284.25},
    {"x":130,"y":278.25},
    {"x":132,"y":284.25},
    {"x":118,"y":284.25},
    {"x":112,"y":282.25},
    {"x":106,"y":278.25},
    {"x":104,"y":272.25},
    {"x":102,"y":266.25},
    {"x":98,"y":258.25},
    {"x":98,"y":250.25},
    {"x":98,"y":242.25},
    {"x":100,"y":236.25},
    {"x":104,"y":230.25},
    {"x":110,"y":226.25},
    {"x":116,"y":224.25},
    {"x":114,"y":232.25},
    {"x":108,"y":236.25},
    {"x":102,"y":242.25},
    {"x":96,"y":248.25},
    {"x":90,"y":254.25},
    {"x":86,"y":260.25},
    {"x":88,"y":254.25},
    {"x":90,"y":248.25},
    {"x":94,"y":242.25},
    {"x":96,"y":234.25},
    {"x":88,"y":238.25},
    {"x":82,"y":240.25},
    {"x":76,"y":242.25},
    {"x":70,"y":244.25},
    {"x":64,"y":246.25},
    {"x":62,"y":240.25},
    {"x":68,"y":236.25},
    {"x":74,"y":232.25},
    {"x":80,"y":228.25},
    {"x":86,"y":224.25},
    {"x":92,"y":220.25},
    {"x":98,"y":218.25},
    {"x":106,"y":214.25},
    {"x":100,"y":212.25},
    {"x":94,"y":210.25},
    {"x":88,"y":202.25},
    {"x":82,"y":194.25},
    {"x":80,"y":188.25},
    {"x":82,"y":180.25},
    {"x":88,"y":174.25},
    {"x":94,"y":172.25},
    {"x":100,"y":170.25},
    {"x":108,"y":170.25},
    {"x":116,"y":170.25},
    {"x":122,"y":172.25},
    {"x":122,"y":162.25},
    {"x":126,"y":154.25},
    {"x":128,"y":148.25},
    {"x":134,"y":142.25},
    {"x":136,"y":136.25},
    {"x":140,"y":130.25},
    {"x":146,"y":124.25},
    {"x":150,"y":118.25},
    {"x":154,"y":112.25},
    {"x":160,"y":108.25},
    {"x":168,"y":102.25},
    {"x":176,"y":96.25},
    {"x":182,"y":92.25},
    {"x":188,"y":88.25},
    {"x":198,"y":86.25},
    {"x":208,"y":84.25},
    {"x":216,"y":84.25},
    {"x":226,"y":84.25},
    {"x":236,"y":84.25},
    {"x":246,"y":84.25},
    {"x":254,"y":84.25},
    {"x":262,"y":84.25},
    {"x":270,"y":84.25},
    {"x":280,"y":84.25},
    {"x":290,"y":84.25},
    {"x":298,"y":86.25},
    {"x":304,"y":88.25},
    {"x":310,"y":90.25},
    {"x":316,"y":96.25},
    {"x":320,"y":102.25},
    {"x":328,"y":108.25},
    {"x":334,"y":114.25},
    {"x":340,"y":122.25},
    {"x":346,"y":128.25},
    {"x":352,"y":136.25},
    {"x":358,"y":144.25},
    {"x":360,"y":150.25},
    {"x":362,"y":156.25},
    {"x":366,"y":162.25},
    {"x":368,"y":168.25},
    {"x":370,"y":174.25},
    {"x":372,"y":180.25},
    {"x":372,"y":188.25},
    {"x":372,"y":196.25},
    {"x":372,"y":204.25},
    {"x":366,"y":210.25},
    {"x":364,"y":198.25},
    {"x":362,"y":192.25},
    {"x":358,"y":186.25},
    {"x":356,"y":180.25},
    {"x":352,"y":174.25},
    {"x":346,"y":170.25},
    {"x":340,"y":162.25},
    {"x":336,"y":156.25},
    {"x":330,"y":150.25},
    {"x":326,"y":144.25},
    {"x":320,"y":140.25},
    {"x":314,"y":138.25},
    {"x":308,"y":136.25},
    {"x":300,"y":134.25},
    {"x":290,"y":132.25},
    {"x":284,"y":130.25},
    {"x":278,"y":128.25},
    {"x":270,"y":128.25},
    {"x":262,"y":128.25},
    {"x":254,"y":128.25},
    {"x":246,"y":128.25},
    {"x":236,"y":130.25},
    {"x":226,"y":132.25},
    {"x":218,"y":132.25},
    {"x":210,"y":132.25},
    {"x":198,"y":132.25},
    {"x":192,"y":134.25},
    {"x":188,"y":140.25},
    {"x":182,"y":144.25},
    {"x":176,"y":150.25},
    {"x":168,"y":156.25},
    {"x":162,"y":160.25},
    {"x":156,"y":162.25},
    {"x":152,"y":168.25},
    {"x":146,"y":172.25},
    {"x":140,"y":178.25},
    {"x":134,"y":182.25},
    {"x":128,"y":186.25},
    {"x":124,"y":192.25},
    {"x":120,"y":198.25},
    {"x":118,"y":204.25},
    {"x":114,"y":210.25},
    {"x":112,"y":218.25},
]